import { statsData, featuresData } from '@/mocks/resources';

export default function Features() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14 md:mb-20">
          {statsData.map((stat, index) => (
            <div
              key={stat.label}
              className="text-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            为什么选择老六资源库
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            六大核心优势，打造最值得信赖的资源分享平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuresData.map((feature, index) => (
            <div
              key={feature.title}
              className="p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}